import React from 'react';

const SvgAf = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AF_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AF_svg__b" fill="#fff">
        <use xlinkHref="#AF_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AF_svg__a" />
      <path fill="#1AB11F" mask="url(#AF_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#262626" mask="url(#AF_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#DC0D18"
        mask="url(#AF_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path
        d="M11.333 9.333c0 .986.535 1.847 1.33 2.308m2.772-.06a2.665 2.665 0 0 0 1.232-2.248"
        stroke="#FFF"
        strokeWidth={1.333}
        opacity={0.75}
        strokeLinecap="round"
        mask="url(#AF_svg__b)"
      />
      <ellipse
        fillOpacity={0.5}
        fill="#FFF"
        mask="url(#AF_svg__b)"
        cx={14}
        cy={8.667}
        rx={1.333}
        ry={2}
      />
    </g>
  </svg>
);

export default SvgAf;
